module.exports = __webpack_public_path__ + "media/images/icons/icon-facebook-0b42a79db6903a8be91a153ecaa835a3.svg";